export const REUNION_IATA_CODE = 'RUN';
// Rodrigues (Île Rodrigues, Maurice) — utilisé par la règle R48 (ligne RUN↔RRG Air Austral)
export const RODRIGUES_IATA_CODE = 'RRG';
// Aéroports parisiens (incluant le code ville PAR) — utilisé par la règle R25 (ligne PAR↔DZA)
export const PARIS_IATA_CODES = new Set(['BVA', 'CDG', 'LBG', 'ORY', 'PAR']);
export const METROPOLITAN_FRANCE_IATA_CODES = new Set([
    'AJA',
    'ANE',
    'AVN',
    'BES',
    'BIA',
    'BIQ',
    'BOD',
    'BVA',
    'BVE',
    'BZR',
    'CCF',
    'CDG',
    'CFE',
    'CFR',
    'CHR',
    'CLY',
    'CMF',
    'DCM',
    'DLE',
    'DNR',
    'DOL',
    'EAP',
    'EBU',
    'EGC',
    'ETZ',
    'FNI',
    'FSC',
    'GNB',
    'LBG',
    'LDE',
    'LEH',
    'LIG',
    'LIL',
    'LME',
    'LRH',
    'LRT',
    'LYS',
    'MLH',
    'MPL',
    'MRS',
    'NCE',
    'NTE',
    'ORY',
    'PAR',
    'PGF',
    'PIS',
    'PUF',
    'QJZ',
    'QOP',
    'QXB',
    'QXG',
    'RDZ',
    'RHE',
    'RNS',
    'SNR',
    'SXB',
    'TLN',
    'TLS',
    'TUF',
    'UIP',
    'URO',
    'VAF',
    'XDB',
    'XDT',
    'XHK',
    'XIZ',
    'XOP',
    'XPJ',
    'XRF',
    'XSH',
    'XWG',
    'XYD',
    'XZI',
    'XZN',
    'ZFJ',
    'ZFQ',
    'ZLN',
]);
// Jeton stocké en base à la place de la liste ci-dessus (codes promo, slides, règles
// frais / échéancier) : la liste reste définie ici seulement.
export const LIST_FR_IATA_CODE = 'LIST-FR';
/** Vrai si `iata` est dans `codes`, le jeton LIST-FR valant toute la France métropolitaine. */
export function includesIataCode(codes, iata) {
    if (!iata)
        return false;
    return (codes.includes(iata) ||
        (codes.includes(LIST_FR_IATA_CODE) && METROPOLITAN_FRANCE_IATA_CODES.has(iata)));
}
